export const PROP_LIBRARY_BINARY_PUBLIC_PATH = "/static/props/propLibrary.bin";
